import { render } from "./EeiaAttachments.vue?vue&type=template&id=77ccb897&scoped=true"
import script from "./EeiaAttachments.vue?vue&type=script&lang=js"
export * from "./EeiaAttachments.vue?vue&type=script&lang=js"

import "./EeiaAttachments.vue?vue&type=style&index=0&id=77ccb897&scoped=true&lang=css"

import exportComponent from "/home/runner/work/eeia-spa/eeia-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ccb897"]])

export default __exports__